import { render, staticRenderFns } from "./personal-settlement.vue?vue&type=template&id=778ef892&"
import script from "./personal-settlement.vue?vue&type=script&lang=js&"
export * from "./personal-settlement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports